import { render, staticRenderFns } from "./SignificationInformations.vue?vue&type=template&id=121798b2&"
import script from "./SignificationInformations.vue?vue&type=script&lang=ts&"
export * from "./SignificationInformations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports